var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 2.83333C1.66699 2.36662 1.66699 2.13327 1.75782 1.95501C1.83771 1.79821 1.9652 1.67072 2.122 1.59083C2.30026 1.5 2.53361 1.5 3.00033 1.5H17.0003C17.467 1.5 17.7004 1.5 17.8787 1.59083C18.0355 1.67072 18.1629 1.79821 18.2428 1.95501C18.3337 2.13327 18.3337 2.36662 18.3337 2.83333V3.39116C18.3337 3.61516 18.3337 3.72716 18.3063 3.8313C18.282 3.92359 18.2421 4.01103 18.1882 4.0898C18.1275 4.17869 18.0428 4.25204 17.8736 4.39875L12.5438 9.01792C12.3745 9.16462 12.2898 9.23797 12.2291 9.32687C12.1752 9.40564 12.1353 9.49308 12.111 9.58536C12.0837 9.68951 12.0837 9.80151 12.0837 10.0255V14.382C12.0837 14.5449 12.0837 14.6264 12.0574 14.6969C12.0342 14.7591 11.9964 14.8149 11.9472 14.8596C11.8916 14.9102 11.8159 14.9404 11.6646 15.001L8.83125 16.1343C8.52497 16.2568 8.37182 16.3181 8.24889 16.2925C8.14138 16.2702 8.04704 16.2063 7.98637 16.1148C7.91699 16.0101 7.91699 15.8452 7.91699 15.5153V10.0255C7.91699 9.80151 7.91699 9.68951 7.88962 9.58536C7.86536 9.49308 7.82544 9.40564 7.77158 9.32687C7.71081 9.23797 7.62617 9.16462 7.4569 9.01792L2.12708 4.39875C1.95781 4.25204 1.87318 4.17869 1.8124 4.0898C1.75855 4.01103 1.71862 3.92359 1.69436 3.8313C1.66699 3.72716 1.66699 3.61516 1.66699 3.39116V2.83333Z",
    stroke: "#808080",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.5e49418da44e2ce609ba4f402f15b17d.svg";
export { ForwardRef as ReactComponent };